import React from "react";
import values from "lodash/values";
import groupBy from "lodash/groupBy";
import List from "../list/list.jsx";
import PassSubscriptionListItem from "./pass-subscription-list-item.jsx";

class PassSubscriptionList extends React.Component {
  render() {
    // grouped by event
    let items = values(this.props.passSubscriptions);

    return (
      <List
        items={items}
        timeGetter={i => i.created_at}
        ListItem={PassSubscriptionListItem}
        dontBreakIntoSections={true}
        hideDateHeaders={true}
        hidePastHeader={true}
        hideActions={this.props.hideActions}
      />
    );
  }
}

export default PassSubscriptionList;



// WEBPACK FOOTER //
// ./src/app/components/partials/pass-subscription-list/pass-subscription-list.jsx